import keyMirror from 'keymirror'

export default keyMirror({
  GET_USER_SUBSCRIPTION_REQUEST: null,
  GET_USER_SUBSCRIPTION_SUCCESS: null,
  GET_USER_SUBSCRIPTION_FAILED: null,

  GET_LIST_VEHICLES_SHARING_EXTENSION_REQUEST: null,
  GET_LIST_VEHICLES_SHARING_EXTENSION_SUCCESS: null,
  GET_LIST_VEHICLES_SHARING_EXTENSION_FAILED: null,

  GET_DETAIL_VEHICLES_SHARING_REQUEST: null,
  GET_DETAIL_VEHICLES_SHARING_SUCCESS: null,
  GET_DETAIL_VEHICLES_SHARING_FAILED: null,

  GET_SUBSCRIPTION_ALLOWED_PILOTS_REQUEST: null,
  GET_SUBSCRIPTION_ALLOWED_PILOTS_SUCCESS: null,
  GET_SUBSCRIPTION_ALLOWED_PILOTS_FAILED: null,

  FORCE_STATUS_TEMPORAL_EXTENSION_REQUEST: null,
  FORCE_STATUS_TEMPORAL_EXTENSION_SUCCESS: null,
  FORCE_STATUS_TEMPORAL_EXTENSION_FAILED: null,

  FORCE_STATUS_PERMANENT_EXTENSION_REQUEST: null,
  FORCE_STATUS_PERMANENT_EXTENSION_SUCCESS: null,
  FORCE_STATUS_PERMANENT_EXTENSION_FAILED: null,

  FORCE_STATUS_UNIQUE_EXTENSION_REQUEST: null,
  FORCE_STATUS_UNIQUE_EXTENSION_SUCCESS: null,
  FORCE_STATUS_UNIQUE_EXTENSION_FAILED: null,

  FORCE_STATUS_CHECK_IN_REQUEST: null,
  FORCE_STATUS_CHECK_IN_SUCCESS: null,
  FORCE_STATUS_CHECK_IN_FAILED: null,

  FORCE_STATUS_CHECK_OUT_REQUEST: null,
  FORCE_STATUS_CHECK_OUT_SUCCESS: null,
  FORCE_STATUS_CHECK_OUT_FAILED: null,

  GET_NOTIFICATION_PUSH_REQUEST: null,
  GET_NOTIFICATION_PUSH_SUCCESS: null,
  GET_NOTIFICATION_PUSH_FAILED: null,

  GET_NOTIFICATION_IN_APPS_REQUEST: null,
  GET_NOTIFICATION_IN_APPS_SUCCESS: null,
  GET_NOTIFICATION_IN_APPS_FAILED: null
})
